import { render, staticRenderFns } from "./listaCampos.vue?vue&type=template&id=0215bbae&scoped=true"
import script from "./listaCampos.vue?vue&type=script&lang=js"
export * from "./listaCampos.vue?vue&type=script&lang=js"
import style0 from "./listaCampos.vue?vue&type=style&index=0&id=0215bbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215bbae",
  null
  
)

export default component.exports